<template>
  <div
    :class="`${wrapper}__share`"
    class="button button_auxilliary"
    @click="managePopupState({ popup: 'sharer', _state: true })"
  >
    <span>{{ $t("VUE.SHARE") }} :</span>
    <div class="button__icons">
      <img
        v-for="({ src, alt }, index) in icons"
        :key="`${src}_${index}`"
        :src="src"
        :alt="alt"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "Share",
  props: {
    icons: {
      type: Array,
      required: true
    },
    wrapper: String
  },
  methods: {
    ...mapMutations(["managePopupState"])
  }
};
</script>
